import { MasterButton } from "App/Component/ui";
import { instance3 } from "App/constants";
import { oneMonthBeforeToday, today } from "App/utils/helpers";
import { toFirstHoursDay, toLastHoursDay } from "utils/dates";

const urlDelete = "/poolKunjungan/delete";

export const deleteKunjunganById = async (id) => {
  try {
    const res = await instance3.post(urlDelete, { id });
    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "tagihan_id",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama_rm",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "id_rm",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
    minWidth: "130px",
  },
  {
    id: "status_tagihan",
    disablePadding: true,
    label: "STATUS TAGIHAN",
    sort: false,
    align: "center",
    minWidth: "130px",
  },
  {
    id: "tgl_tagihan",
    disablePadding: true,
    label: "TGL TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "penanggung",
  //   disablePadding: true,
  //   label: "PENANGGUNG",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
  // {
  //   id: "tlg_perwatan_awal",
  //   disablePadding: true,
  //   label: "TGL PERAWATAN AWAL",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
  // {
  //   id: "tlg_perwatan_akhir",
  //   disablePadding: true,
  //   label: "TGL PERAWATAN AKHIR",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
  {
    id: "asuransi",
    disablePadding: true,
    label: "ASURANSI",
    sort: false,
    align: "left",
    minWidth: "150px",

  },
  {
    id: "no_asuransi",
    disablePadding: true,
    label: "NO. ASURANSI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "jenis_layanan",
  //   disablePadding: true,
  //   label: "JENIS LAYANAN",
  //   sort: false,
  //   align: "left",
  //   minWidth: "150px",
  // },
  {
    id: "total_tagihan",
    disablePadding: true,
    label: "TOTAL TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "selisih_tagihan",
  //   disablePadding: true,
  //   label: "SELISIH DITANGGUNG",
  //   sort: false,
  //   align: "left",
  //   minWidth: "150px",
  // },
  {
    id: "dibayar",
    disablePadding: true,
    label: "DIBAYAR",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "sisa",
    disablePadding: true,
    label: "SISA",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
 
  // {
  //   id: "createdAt",
  //   disablePadding: true,
  //   label: "CREATED AT",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
  // {
  //   id: "createdBy",
  //   disablePadding: true,
  //   label: "CREATED BY",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
  // {
  //   id: "updatedAt",
  //   disablePadding: true,
  //   label: "UPDATED AT",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
  // {
  //   id: "updatedBy",
  //   disablePadding: true,
  //   label: "UPDATED BY",
  //   sort: false,
  //   align: "left",
  //   minWidth: "180px",
  // },
];

export const headCellsModal = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "IDGL",
    disablePadding: false,
    label: "IDGL",
    align: "left",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "no_sep",
    disablePadding: false,
    label: "NO SEP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tgl_awal_rawat",
    disablePadding: false,
    label: "TANGGAL AWAL RAWAT",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "tgl_pulang",
    disablePadding: false,
    label: "TANGGAL PULANG",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "nama_asuransi",
    disablePadding: false,
    label: "NAMA ASURANSI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "statusTagihan",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "selisihTagihan",
    disablePadding: false,
    label: "SELISIH DITANGGUNG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "selisihPaket",
    disablePadding: false,
    label: "SELISIH PAKET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "totalTagihan",
    disablePadding: false,
    label: "TOTAL TAGIHAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "total_bayar",
    disablePadding: false,
    label: "TOTAL PEMBAYARAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "sisa",
    disablePadding: false,
    label: "SISA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  kategori_pencarian: 0,
  kata_kunci: "",

  nama: "",
  rm_id: "",
  eklaim_status: "",

  asuransi_id: null,
  asuransi_name: "Pilih Asuransi",

  jenis_layanan_id: null,
  jenis_layanan_name: "Pilih Jenis Layanan",

  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(false),
};

export const addBulkTagihan = async (
  idRekapTagihan,
  data,
  urlBulk = "/rekap-tagihan/add-item"
) => {
  try {
    const response = await instance3.post(urlBulk, {
      rekap_tagihan_id: idRekapTagihan,
      data: data,
    });

    if (response.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menambahkan tagihan",
      };
    } else {
      return {
        state: false,
        message: response.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const bulkHapusTagihan = async (
  idRekapTagihan,
  data,
  urlBulk = "/rekap-tagihan/delete-item"
) => {
  try {
    const response = await instance3.post(urlBulk, {
      id_tagihan: idRekapTagihan,
      detail: data,
    });

    if (response.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus tagihan",
      };
    } else {
      return {
        state: false,
        message: response.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};


export const getByFilterTagihan = async (formFilter, pages, limit) => {
  try {
    const data = {
      halaman: pages,
      jumlah: limit,
      nama: formFilter.nama,
      eklaim_status: formFilter.eklaim_status,

      tanggal_awal: toFirstHoursDay(formFilter.tanggal_awal),
      tanggal_akhir: toLastHoursDay(formFilter.tanggal_akhir),
      asuransi_id: formFilter.asuransi_id,
      jenis_layanan_id: formFilter.jenis_layanan_id,
      statusTagihan:1,
    };

    const katPencarianData = {
      0: "semua",
      1: "id_tagihan",
      2: "rm_id",
      3: "nama_rm",
    };

    const katPencarian = katPencarianData[formFilter.kategori_pencarian];

    const kataKunci =
      katPencarian !== "semua"
        ? {
            [katPencarian]: formFilter.kata_kunci,
          }
        : {};

    const api = await instance3.post("/tagihan/list-forrekap", {
      ...data,
      ...kataKunci,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
        total: res.total,
        pembayaran: res.pembayaran,
        sisa: res.sisa,
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCellsUpload = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACT",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    minWidth: "50px",
  },
  {
    id: "id_rekap",
    disablePadding: true,
    label: "ID REKAP",
    sort: false,
    align: "left",
    minWidth: "50px",
  },
  {
    id: "stat",
    disablePadding: true,
    label: "STATUS",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "data_gagal",
    disablePadding: true,
    label: "TOTAL DATA GAGAL",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "data_masuk",
    disablePadding: true,
    label: "TOTAL DATA MASUK",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "total_data",
    disablePadding: true,
    label: "TOTAL DATA",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "remark",
    disablePadding: true,
    label: "CATATAN",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const headCellsDetail = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    minWidth: "50px",
  },
  {
    id: "id_log",
    disablePadding: true,
    label: "ID REKAP",
    sort: false,
    align: "left",
    minWidth: "50px",
  },
  {
    id: "id_tagihan",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
    width: "150px",
  },
  {
    id: "id_rekap",
    disablePadding: true,
    label: "ID REKAP",
    sort: false,
    align: "left",
    minWidth: "50px",
  },
  {
    id: "catatan",
    disablePadding: true,
    label: "CATATANL",
    sort: false,
    align: "left",
    minWidth: "280px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const StatusImport = ({ str }) => {
  if (parseInt(str) === 0) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SEDANG DIPROSES"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (parseInt(str) === 1) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"green"}
        type='button'
        disabled
      />
    );
  }else if (parseInt(str) === 99) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PROSES GAGAL"}
        color={"danger"}
        type='button'
        disabled
      />
    );
  }else{
    return(
      "Tidak Ditemukan"
    );
  }
};


export const headCellsLog = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "proses",
    disablePadding: false,
    label: "PROSES",
    align: "center",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    minWidth: "50px",
  },
  {
    id: "id_rekap",
    disablePadding: true,
    label: "ID REKAP",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "data_gagal",
    disablePadding: true,
    label: "TOTAL DATA GAGAL",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "data_masuk",
    disablePadding: true,
    label: "TOTAL DATA MASUK",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "total_data",
    disablePadding: true,
    label: "TOTAL DATA",
    sort: false,
    align: "left",
    minWidth: "180px",
  },
  {
    id: "stat",
    disablePadding: true,
    label: "STATUS",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: true,
    label: "CATATAN",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
];
